export default __webpack_public_path__ + "static/ocean-circle-91dc3e62a2ece5dd76dd000771cb2b58.png";